// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__jI1jp","rootSmall":"AddTileButton_rootSmall__2_wx3"};